import React, { useCallback, useContext } from "react";
import { IFailureCodesProps } from "../FailureDetailsInterfaces";
import { HMIContext } from "../../../../../contexts/HMIContext/HMIContext";
import { FailureDetailsButton } from "../../../../../components/FailureDetailsButton/FailureDetailsButton.view";
import { useStyles } from "../FailureDetails.styles";
import { Grid } from "@mui/material";
import { IFailureCode } from "../../../../../contexts/HMICachedDataContext/HMICachedDataContextInterfaces";
import { setCurrentFailureCode } from "../../../../../utilities/storageUtilities";
import { DefaultTranslationFieldsInTable, FAILUREDETAILSSTEPS } from "../../../../../constants/constants";
import { useTranslation } from "react-i18next";
import { translateDefaultEntity } from "utilities/localesUtilities";

export const FailureCodesButtons = ({ failureCodes }: IFailureCodesProps) => {
    const { handleFailureCode, handleSetFailureDetailStep } = useContext(HMIContext);
    const classes = useStyles();
    const { i18n } = useTranslation();

    const handleOnClick = useCallback(
        (failureCode: IFailureCode) => {
            return (event: React.MouseEvent) => {
                event.preventDefault();
                handleFailureCode(failureCode);
                setCurrentFailureCode(failureCode);
                handleSetFailureDetailStep(FAILUREDETAILSSTEPS.FAILUREDETAILSSELECTIONS);
            };
        },
        [handleFailureCode, handleSetFailureDetailStep],
    );

    return (
        <Grid container className={classes.failureButtonsContainer}>
            {failureCodes &&
                failureCodes.map((failureCode: IFailureCode) => (
                    <Grid item xs={5.8} key={failureCode.failure_code_id}>
                        <FailureDetailsButton
                            onClick={handleOnClick(failureCode)}
                            name={
                                translateDefaultEntity(
                                    i18n.language,
                                    failureCode,
                                    "name",
                                    DefaultTranslationFieldsInTable.FAILURE_CODE,
                                ) as string
                            }
                        />
                    </Grid>
                ))}
        </Grid>
    );
};
